

















import { Component, Vue } from "vue-property-decorator";
import FolderListView from "../components/folder/FolderListView.vue";
import DownloadHistoryView from "../components/history/DownloadHistoryView.vue";
import FolderHistoryView from "../components/history/FolderHistoryView.vue";
import { DomainRegistry } from "@/domain";

@Component({
  components: {
    FolderListView,
    DownloadHistoryView,
    FolderHistoryView,
  }
})
export default class Home extends Vue {
  data() {
    return {
      componentKey: "FolderListView",
    };
  }
  componentKey: string;

  get userId(): string {
    return !!this.$store.getters.user
      ? this.$store.getters.user.id
      : "";
  }

  async logout(): Promise<void> {
    try {
      const service = DomainRegistry.authentication.getAuthenticationService();
      await service.logout();
    } catch (e) {
      console.error(e);
    }
    this.$router.replace("/Login");
  }
}
